export const isAllowInterest = (process.env.NEXT_PUBLIC_ALLOW_INTEREST ?? "true") === "true";
export const isAllowWhatsapp = (process.env.NEXT_PUBLIC_ALLOW_WHATSAPP ?? "true") === "true";
export const isAllowLogin = (process.env.NEXT_PUBLIC_ALLOW_LOGIN ?? "true") === "true";